import n from "./index41.js";
import { openBlock as t, createElementBlock as a, createElementVNode as o, normalizeClass as c, pushScopeId as i, popScopeId as l } from "vue";
import "./index42.js";
import p from "../../../../_virtual/index.js";
const s = (e) => (i("data-v-20a0f40b"), e = e(), l(), e), r = { class: "mobile-navigation-menu" }, _ = /* @__PURE__ */ s(() => /* @__PURE__ */ o("span", { class: "line-1" }, null, -1)), d = /* @__PURE__ */ s(() => /* @__PURE__ */ o("span", { class: "line-2" }, null, -1)), m = /* @__PURE__ */ s(() => /* @__PURE__ */ o("span", { class: "line-3" }, null, -1)), u = [
  _,
  d,
  m
];
function f(e, h, b, v, I, $) {
  return t(), a("div", r, [
    o("div", {
      class: c(["mobile-hamburger-menu", e.showMenu ? "menu-open" : ""])
    }, u, 2)
  ]);
}
const w = /* @__PURE__ */ p(n, [["render", f], ["__scopeId", "data-v-20a0f40b"]]);
export {
  w as default
};
//# sourceMappingURL=index36.js.map
